import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import configureStore from "./store";
import { I18nextProvider } from "react-i18next";
import i18n from "./locale/i18n";

const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <React.StrictMode>        
        <App />
      </React.StrictMode>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
